
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";



class EquipmentApi extends baseApi {


    getOne = async (id) => {

        return await this.get(`?app=Equipment&act=getOne&id=${id}`)

    }

     getList = async (data) => {

        return await this.post('?app=Equipment&act=getList', data)

    }


     save = async (data) => {
        return await this.post('?app=Equipment&act=save', {data:JSON.stringify(data)})

    }

    delete = async (id) => {
        return await this.post('?app=Equipment&act=setDeleted', {id})

    }

}

export default new EquipmentApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);